import { Bus } from './../../../models/bus';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Passenger } from './../../../models/passenger';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { Select2OptionData } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';
declare const google: any;
import * as moment from 'moment';
import { Journey } from './../../../models/journey';


@Component({
  selector: 'app-passenger-edit',
  templateUrl: './passenger-edit.component.html',
  styleUrls: ['./passenger-edit.component.css']
})
export class PassengerEditComponent implements OnInit {

  isAssistant: boolean;
  routeBase: string;
  PgNo: any;
  PgLen: any;

  passenger: Passenger;
  clients: any[];
  clientId: any;
  schools: any[];
  school: any;
  bus: any;
  busMaxLoad = 0;
  countPassengers = 0;
  restPassengers = 0;
  TotalPassengers = 0;
  journeyLoads: any[];
  initialCount;
  oldBus: any;
  buses: any[];
  passagerLinkMaps: any;
  phonePassagerInvalide: any = 0;
  linkInvalide: any = 0;
  distanceInvalid: any = 0;
  public clientsData: any[];
  public busesData: any[];
  public subscriptionsData: any[];
  public schoolsData: any[];
  pnotify = undefined;
  option: any;
  map: any;
  markers: any[];
  markerBounds: any;
  isResponsible = false;
  directionsService: any;
  directionsRenderer: any;
  firstNamesRegistrationNumbers: any[] = [];


  filterJourney = {
    date: new Date(),
    inputFrom: '',
    inputTo: '',
    timeInterval: [],
  };
  JourneyloadData: any;
  // ----- Start Ion Range Slider -----------
  ion_min = moment('0000', 'hmm').format('X');
  ion_max = moment('2359', 'hmm').format('X');
  ion_from = moment('0000', 'hmm').format('X');
  ion_to = moment('2359', 'hmm').format('X');
  hourFormat = function (num) {
    const m = moment(num, 'X');
    return m.format('HH:mm');
  };
  formatX = function (time: string) {
    return moment(time, 'h:mm').format('X');
  };
  // ----- Start Ion Range Slider -----------
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.isAssistant = false;
    this.routeBase = 'passenger';
    this.passenger = new Passenger();
    this.route.params.subscribe(params => {
      this.PgNo = params['PgNo'];
      this.PgLen =  params['PgLen'];
      this.http.get(
        '/api/passenger/' + params['id']
      ).subscribe((data: any) => {
        const passenger = data.passenger;
        if (
          (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
          && this.authService.getUser().id !== passenger.School.clientId
        ) {
          this.router.navigate(['']);
        }
        this.passenger = passenger;
        this.clientId = passenger.School.clientId;
        this.journeyLoads = data.journeyLoads;
        this.initialCount = passenger.count;
        this.busMaxLoad = passenger.Bus ? passenger.Bus.maxLoad : 0;
        this.oldBus = passenger.Bus ? passenger.Bus : [];
        this.initFirstnamesRegistrationNumbers(passenger);
        this.initClientSelect();
        this.initSchoolSelect();
        this.subscriptionsData = [
          {
            id: 'Aller/Retour',
            text: 'Aller/Retour',
            selected: this.passenger.subscription == 'Aller/Retour' ? true : false
          },
          {
            id: 'Aller',
            text: 'Aller',
            selected: this.passenger.subscription == 'Aller' ? true : false
          },
          {
            id: 'Retour',
            text: 'Retour',
            selected: this.passenger.subscription == 'Retour' ? true : false
          },
        ];
      });
    });
    this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }

  ngOnInit() {
    this.route.data
      .subscribe((data: { isAssistant: boolean }) => {
        this.routeBase = data.isAssistant ? 'assistant' : 'passenger';
        this.isAssistant = data.isAssistant;
      });
    this.initMap();
    this.map.fitBounds(this.markerBounds);
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        const array1 = [{ id: '', text: 'Choisir un client' }];
        const array2 = this.clients.map((client, index) => {
          return { id: client.id, text: client.name, selected: (client.id == this.clientId) ? true : false };
        });
        this.clientsData = array1.concat(array2);
      });
    }
  }
  clientChanged(e: any) {
    this.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name, selected: (school.id == this.passenger.schoolId) ? true : false };
        }
      });
    });
  }
  schoolChanged(e: any) {
    this.passenger.schoolId = e.value;
    this.schools.forEach((school) => {
      if (school.id == this.passenger.schoolId) {
        this.school = school;
      }
    });
    this.initMap();
    this.map.fitBounds(this.markerBounds);
    this.initBusSelect();
  }

  initBusSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.clientId + '',
        schoolId: this.passenger.schoolId + ''
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map((bus, index) => {
        return { id: bus.id, text: bus.name, selected: (bus.id == this.passenger.busId) ? true : false };
      });
      this.busesData = array1.concat(array2);
    });
  }
  busChanged(e: any) {
    // this.deleteMarkers();
    this.passenger.busId = e.value;
  }

  FirstnamesChanged(InputValueString: any){
    var TabNames = InputValueString.split("/");
    //console.log("Value recieved:" + InputValueString);
    //console.log("table length" + TabNames.length);
    if (TabNames.length == 1 ){
      this.passenger.count = 1;
    }else{
      var numberNamesValid : any = 0;
      for(var i = 0; i < TabNames.length;i++){
        //console.log("TabNames["+i+"] : " + TabNames[i] );
        if (TabNames[i] != "" && TabNames[i] != " "){
          numberNamesValid++;
          //console.log("IN");
        }
      }
      this.passenger.count = numberNamesValid;
    }
    //console.log("passenger.count :" + this.passenger.count);
  }

  initMap() {
    const pos = (this.school) ? { lat: Number(this.school.lat), lng: Number(this.school.lng) } : { lat: 0, lng: 0 };
    this.option = {
      center: pos,
      zoom: 8,
      gestureHandling: 'cooperative',
      scrollwheel: false,
    };
    this.map = new google.maps.Map(document.getElementById('map'), this.option);
    this.markerBounds = new google.maps.LatLngBounds();
    if (this.school) {
      this.markerBounds.extend(new google.maps.LatLng(pos));
      const schoolMarker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: 'assets/images/markers/school.png',
      });
    }
    this.markers = [];
    this.setMarker();
  }

  setMarker() {
    let pos = { lat: 0, lng: 0, };
    if (this.passenger.hasOwnProperty('id')) {
      pos = { lat: Number(this.passenger.lat), lng: Number(this.passenger.lng) };
      this.placeMarker(pos, false);
    } else {
      this.placeMarker(pos, true);
    }
    google.maps.event.addListener(this.map, 'click', (event) => {
      this.placeMarker({lat: event.latLng.lat(), lng: event.latLng.lng()});
    });
  }

  placeMarker(pos, isInit = false) {
    if (this.markers[0]) {
      this.markers[0].setVisible(true);
      this.markers[0].setPosition(pos);
    } else {
      const passangerMarker = new google.maps.Marker({
        position: pos,
        map: this.map,
        icon: 'assets/images/markers/passenger.png',
        draggable: true,
        zIndex: 100,
      });
      this.markers.push(passangerMarker);
    }

     // Clear map link if position set by Maps
     this.passagerLinkMaps = "";

    this.passenger.lat = pos.lat;
    this.passenger.lng = pos.lng;
    google.maps.event.addListener(this.markers[0], 'dragend', (e) => {
      this.passenger.lat = e.latLng.lat();
      this.passenger.lng = e.latLng.lng();
    });
    if (!isInit &&
      (this.passenger.lat != null && this.passenger.lat !== 0) &&
      (this.passenger.lng != null && this.passenger.lng !== 0)) {
      this.passenger.isPositionValide = true;
      this.markerBounds.extend(new google.maps.LatLng({ lat: this.passenger.lat, lng: this.passenger.lng }));
    }
  }

  changeHistoryJourney(){
    const inputFrom = this.getElapsedSecondsInDay(this.filterJourney.inputFrom);
    const inputTo   = this.getElapsedSecondsInDay(this.filterJourney.inputTo);
    if (inputFrom > inputTo) {
      this.filterJourney.inputTo = '';
    } else {
      this.filterJourney.timeInterval = [inputFrom, inputTo];
    }
  }

  getDataFromBus(id) {
    return function (element) {
      return element.busId === id;
    };
  }

  onFilterJourney() {
    this.JourneyloadData = true;
    //this.refreshMap();
    this.initMap();

    let params = new HttpParams({
      fromObject: {
        schoolId: this.passenger.schoolId + '',
        busIds: JSON.stringify([this.passenger.busId]),
        date: moment(this.filterJourney.date).format('YYYY-MM-DD'),
        timeInterval: JSON.stringify(this.filterJourney.timeInterval)
      }
    });
    let url = '/api/bus/mapJourney';

    this.http.get(url, { params })
        .subscribe(
          (data: any) => {

            if (!data.positions.length) {
              this.JourneyloadData = false;
            }
            for (let index = 0; index < data.buses.length; index++) {
              const positions = data.positions.filter(this.getDataFromBus(data.buses[index].id));
              if (positions.length > 0) {
                const color = '#34495e';
                this.createLineBus(data.buses[index], positions, this.map, color);
              }

            }
            this.map.fitBounds(this.markerBounds);
          },
          error => {
            this.JourneyloadData = false;
          }
        );

  }

  initFirstnamesRegistrationNumbers(passenger) {

    const firstNames = passenger.firstnames.split('/');
    const registrationNumbers = passenger.registrationNumbers.split('/');
    
    // Check if lengths match and create objects accordingly
    if (firstNames.length === registrationNumbers.length) {
        this.firstNamesRegistrationNumbers = firstNames.map((firstName, index) => {
            return { firstname: firstName.trim(), RegistrationNumber: registrationNumbers[index].trim() };
        });
    } else {
        this.firstNamesRegistrationNumbers = firstNames.map((firstName, index) => {
          return { firstname: firstName.trim(), RegistrationNumber: '-' };
        });
        //console.error('Lengths of first names and registration numbers do not match.');
    }
  }

  addFirstname() {
    this.firstNamesRegistrationNumbers.push ( {firstname: '', RegistrationNumber: ''});
  }

  removeFirstname(index){
    this.firstNamesRegistrationNumbers.splice(index, 1);
  }


  updatePassengerFirstNamesRegistrationNumbers() {
    if (this.firstNamesRegistrationNumbers.length > 1) {
        this.passenger.firstnames = this.firstNamesRegistrationNumbers.map(item => item.firstname).join('/');
        this.passenger.registrationNumbers = this.firstNamesRegistrationNumbers.map(item => item.RegistrationNumber).join('/');
        this.passenger.count = this.firstNamesRegistrationNumbers.length;
    } else if (this.firstNamesRegistrationNumbers.length === 1) {
        this.passenger.firstnames = this.firstNamesRegistrationNumbers[0].firstname;
        this.passenger.registrationNumbers = this.firstNamesRegistrationNumbers[0].RegistrationNumber;
        this.passenger.count = 1;
    }
  }

  createLineBus(bus, locations, map, color) {
    const infowindow = new google.maps.InfoWindow();
    const path = [];
    for (let i = 0; i < locations.length; i++) {
      const isFirst = i === 0 ? true : false;
      const isLast = i === locations.length - 1 ? true : false;

      const pos = new google.maps.LatLng(parseFloat(locations[i].lat), parseFloat(locations[i].lng));
      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(pos);

      let content = '';
      let label = null;
      let icon = null;
      if (isFirst && i === 0) {
        content = '<h1 style="text-align: center;">Départ</h1>';
        label = 'JD';
      } else if (isLast && i === locations.length - 1) {
        content = '<h1 style="text-align: center;">Arrivée</h1>';
        label = 'JA';
      } else if (locations[i].speed === 0) {
        icon = {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 6,
            strokeColor: '#ffffff',
            strokeWeight: 2,
            fillColor: '#F00',
            fillOpacity: 0.9
        };
      } else {
        icon = {
            path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
            scale: 3.5,
            strokeColor: '#ffffff',
            strokeWeight: 1,
            fillColor: color,
            fillOpacity: 0.9,
            rotation: locations[i].angle
        };
      }


      // window.alert(locations[i].angle);
      const marker = new google.maps.Marker({
          position: pos,
          map: map,
          label: label,
          icon: icon
       });
      this.markerBounds.extend(pos);

      const this_ = this;
      marker.addListener('click', function () {
        const position = locations[i].lat + ',' + locations[i].lng;

        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Position :</b> ${position} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
       });

      marker.addListener('mouseover', function() {
        content = `<b>Bus :</b> ${bus.name}<br/>
        <b>Date :</b> ${ moment.utc(locations[i].time).format('DD/MM/YYYY à HH:mm:ss')} <br/>
        <b>Vitesse :</b> ${locations[i].speed} km/h<br/>`;

        content += (locations[i].BusEvent) ? `<b>Message :</b> ${locations[i].BusEvent.message}` : '';

        infowindow.setContent(content);
        infowindow.open(map, marker);
      });
      marker.addListener('mouseout', function() {
        infowindow.close();
      });

      if (isLast) {
        this.JourneyloadData = false;
      }
    }
    const poly = new google.maps.Polyline({
      path: path,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 0.8,
      strokeWeight: 3,
    });
    poly.setMap(map);

  }


  onLatLngChange() {
    if (this.passenger.lat != null && this.passenger.lng != null) {
      this.passenger.isPositionValide = true;
      this.markers[0].setVisible(true);
      this.markers[0].setPosition({
        lat: this.passenger.lat,
        lng: this.passenger.lng
      });
    } else {
      this.passenger.isPositionValide = false;
    }
  }

  extractNumbers(input: string): number[] {
    // Define a regular expression to match decimal numbers with optional negative sign
    const regex = /-?\d+(\.\d+)?/g;

    // Use the match method to find all matches in the input string
    const matches = input.match(regex);

    // Convert the matched strings to numbers and return the result
    return matches ? matches.map(Number) : [];
  }

  onLinkChange() {
    if (this.passagerLinkMaps != null && this.passagerLinkMaps != "") {
      
       // Extract latitude and longitude from the Google Maps link
       var splitUrl = this.passagerLinkMaps.split('!3d');
       var latLong = splitUrl[splitUrl.length-1].split('!4d');
       var lng;
 
       var lat = parseFloat(latLong[0]);
 
       var results = this.extractNumbers(latLong[1]);//Get numbers
       lng = results[0];//get the first nubmer

      console.log(lat);
      console.log(lng);

      // Check if latitude and longitude values are valid
      if (!isNaN(lat) && !isNaN(lng)) {

        // You now have the lat and lng values, you can use them as needed
        this.passenger.lat = lat;
        this.passenger.lng = lng;
        if (this.markers[0]) {
          this.markers[0].setVisible(true);
          this.markers[0].setPosition({
            lat: this.passenger.lat,
            lng: this.passenger.lng
          });
        } else {
          const passangerMarker = new google.maps.Marker({
            position: {lat: this.passenger.lat, lng: this.passenger.lng},
            map: this.map,
            icon: 'assets/images/markers/passenger.png',
            draggable: true,
            zIndex: 100,
          });
          this.markers.push(passangerMarker);
        }

        // Get the current date
        const currentDate = new Date();
        // Format the date as "dd:mm:yyyy"
        const formattedDate = `[${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}]`;
        // Concatenate the formatted date and the Google Maps link
        this.passenger.address = this.passenger.address + `\n${formattedDate} \nAdresse Maps: ${this.passagerLinkMaps}`;
        this.passenger.isPositionValide = true;
      } else {
        // Invalid link, show the invalid link message
        this.linkInvalide = 1;
        //Info ('Invalid Google Maps link');
        
      }
    } 
  }

  phoneNumberPatternValidator() {
    const phoneNumberPattern = /^0[6-7]{1}[0-9]{8}$/;
    
    // Phone Driver check
    if (phoneNumberPattern.test(this.passenger.phone)) {
      this.phonePassagerInvalide = 0; // Valid pattern
    } else {
      this.phonePassagerInvalide = 1; // Invalid pattern
    }

  }

  checkFieldValidator () {
    this.phoneNumberPatternValidator(); // Check phone driver
    this.updatePassengerFirstNamesRegistrationNumbers();
    this.checkPositionDistance (); // check if distance with school is valid
  }

  checkPositionDistance () {
    if (this.passenger.isPositionValide){
      const distance = this.getDistanceFromLatLonInKm(this.school.lat, this.school.lng, this.passenger.lat, this.passenger.lng);
      // 1 if Invalid distance, show the invalid distance message
      this.distanceInvalid = distance > 35;
    } else {
      this.distanceInvalid = false;
    }
  }

  getDistanceFromLatLonInKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    const dLon = this.deg2rad(lon2 - lon1); 
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2); 
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)); 
    const distance = R * c; // Distance in km
    return distance;
  }
  
  deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  initPosition(isChecked) {
    if (isChecked == false){
      this.pnotify.notice({
        title: 'Confirmation',
        text: 'Le suppression de la position entraine la désinscription de tous ses trajets. Voules-vous continuer ?',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Ok',
                addClass: 'btn btn-chico',
                click: notice => {
                  notice.close();
                  this.updatejournysPassenger();
                }
              },
              {
                text: 'Annuler',
                addClass: 'btn btn-default',
                click: (notice) => {
                  this.passenger.isPositionValide = true;
                  notice.close();
                  notice.fire('pnotify.cancel', { notice });
                }
              }
            ]
          }
        }
      });
    }


  }

  updatejournysPassenger(){
    this.passenger.lat = null;
    this.passenger.lng = null;
    this.passenger.isPositionValide = false;
    // Hide the marker
    if (this.markers.length > 0) {
      this.markers[0].setVisible(false);
      //this.markers[0].setMap(null);
    }

    this.http.put('/api/passenger/removePassengerFromJourneys/' +  this.passenger.id,
      {}
    ).subscribe(
      (resp: any)  => {
        this.updateAffectedjourneys(resp.AffectedJourneyIds);
      }
    );
  }

  deleteMarkers() {
    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];
  }
  subscriptionChanged(e: any) {
    this.passenger.subscription = e.value;
  }

  am1Change($event) {
    this.passenger.am1Start = moment($event.from * 1000).format('X');
    this.passenger.am1End = moment($event.to * 1000).format('X');
  }
  am2Change($event) {
    this.passenger.am2Start = moment($event.from * 1000).format('X');
    this.passenger.am2End = moment($event.to * 1000).format('X');
  }
  pm1Change($event) {
    this.passenger.pm1Start = moment($event.from * 1000).format('X');
    this.passenger.pm1End = moment($event.to * 1000).format('X');
  }
  pm2Change($event) {
    this.passenger.pm2Start = moment($event.from * 1000).format('X');
    this.passenger.pm2End = moment($event.to * 1000).format('X');
  }

  passengerCountChanged() {
    this.TotalPassengers = Number(this.countPassengers) + Number(this.passenger.count);
  }

  updateAffectedjourneys(AffectedJourneyIds: any) {
    let journey: any;
    let results: any;

    for (let i = 0; i < AffectedJourneyIds.length; i++) {
      this.http.get(
        '/api/journey/findOne/' + AffectedJourneyIds[i]
      ).subscribe((_journey: Journey) => {
        journey = _journey;

        results = this.calculateNewRoute(journey);
      });
    }
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  calculateNewRoute(_journey: Journey) {
    const journey: Journey = _journey;
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    const waypts = [];
    let PositionPassager: any;

    journey.start = new Date(Number(_journey.start) * 1000);
    journey.JourneyPassengers.forEach((JourneyPassenger) => {
      PositionPassager = new google.maps.LatLng(Number(JourneyPassenger.Passenger.lat), Number(JourneyPassenger.Passenger.lng));
      waypts.push({
        location: PositionPassager,
        stopover: true
      });
    });

    this.directionsService.route({
      origin: { lat: Number(journey.startPositionLat), lng: Number(journey.startPositionLng) },
      destination: { lat: Number(journey.endPositionLat), lng: Number(journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: 'DRIVING'
    }, (response, status) => {
      let distancetrajet: any = 0;
      let TimeEstimatedPassager: any = this.getElapsedSecondsInDay(journey.start);
      if (journey.type === ('M1' || 'AM1')) {
        journey.waitTimePassager = 20;
      } else {
        journey.waitTimePassager = 0;
      }
      if (status === 'OK') {
        // this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (waypts.length > 0) {
          const route = response.routes[0];
          // 1- Ajouter la distance et la durée du point depart au premier passager
          distancetrajet = distancetrajet + route.legs[0].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[0].duration.value;
          journey.JourneyPassengers[0].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          // 2- Ajouter la distance et la durée pour chaque point d'arret
          for (let i = 1; i <= route.legs.length - 2; i++) {
            distancetrajet = distancetrajet + route.legs[i].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + route.legs[i].duration.value + journey.waitTimePassager;
            journey.JourneyPassengers[i].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          }
          // 3- Ajouter la distance et la durée pour aller au point destinations
          distancetrajet = distancetrajet + route.legs[route.legs.length - 1].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[route.legs.length - 1].duration.value;

          journey.distance = Number((distancetrajet / 1000).toFixed(0));
          journey.end = new Date(Number(TimeEstimatedPassager) * 1000);

        }
        journey.start = this.getElapsedSecondsInDay(journey.start);
        journey.end = this.getElapsedSecondsInDay(journey.end);
        journey.JourneyPassengers.forEach((journeyPassenger, index) => {
          journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
          journeyPassenger.order = index + 1;
        });
        // Update server
        this.http.put(
          '/api/journey/' + journey.id,
          { journey: journey }
        ).subscribe(() => {},
          (error) => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
      } else {
        console.log ('Directions request failed due to ' + status);
      }
    });
  }


  onSubmit() {
    this.updatePassengerFirstNamesRegistrationNumbers();
    this.passenger.lastConnection = moment(this.passenger.lastConnection).format('YYYY-MM-DD HH:mm:ss');
    if (this.oldBus.id == this.passenger.busId && this.initialCount != this.passenger.count) {
      let msgs = '';
      this.journeyLoads.forEach((journeyLoad) => {
        const deltaCount = Number(this.initialCount) - this.passenger.count;
        const countPassanger = Number(journeyLoad.load) + deltaCount;
        if (countPassanger > this.busMaxLoad) {
          msgs += '- ' + journeyLoad.Journey.name + '\n';
        }
      });
      if (msgs != '') {
        this.pnotify.error({
          title: 'Erreur',
          text: 'La charge maximale est dépassée sur les trajets suivants :\n' + msgs,
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Confirmer',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    this.updatePassenger();
                    notice.close();
                  }
                },
                {
                  text: 'Annuler',
                  addClass: 'btn btn-chico',
                  click: (notice) => {
                    notice.close();
                    notice.fire('pnotify.cancel', { notice });
                  }
                }
              ]
            }
          }
        });
      } else {
        this.updatePassenger();
      }
    } else {
      this.updatePassenger();
    }
  }

  updatePassenger() {
    if (this.passenger.subscription == 'Aller') {
      this.passenger.am2Start = moment('0000', 'hmm').format('X');
      this.passenger.am2End = moment('2359', 'hmm').format('X');
      this.passenger.pm2Start = moment('0000', 'hmm').format('X');
      this.passenger.pm2End = moment('2359', 'hmm').format('X');
    } else if (this.passenger.subscription == 'Retour') {
      this.passenger.am1Start = moment('0000', 'hmm').format('X');
      this.passenger.am1End = moment('2359', 'hmm').format('X');
      this.passenger.pm1Start = moment('0000', 'hmm').format('X');
      this.passenger.pm1End = moment('2359', 'hmm').format('X');
    }
    this.http.put(
      '/api/passenger/' + this.passenger.id,
      { passenger: this.passenger }
    ).subscribe(
      (passenger: Passenger) => {
        this.passenger = passenger;
        this.router.navigate(['/' + this.routeBase + '/view', this.passenger.id, this.PgNo, this.PgLen]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger/passenger-edit/passenger-edit.component.ts